import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import { AssignableTasksPage } from "./components/Pages/AssignableTasksPage/AssignableTasksPage";
import { ErrorPage } from "./components/Pages/ErrorPage/ErrorPage";
import { HomePage } from "./components/Pages/HomePage/HomePage";
import { LoadingPage } from "./components/Pages/LoadingPage/LoadingPage";
import { LoginPage } from "./components/Pages/LoginPage/LoginPage";
import { NotificationsPage } from "./components/Pages/NotificationsPage/NotificationsPage";
import { PprofilePage } from "./components/Pages/ProfilePage/ProfilePage";
import { SetUpPage } from "./components/Pages/SetUpPage/SetUpPage";
import { TaskCommentsPage } from "./components/Pages/TaskCommentsPage/TaskCommentsPage";
import { TaskPage } from "./components/Pages/TaskPage/TaskPage";
import { UserCommentsPage } from "./components/Pages/UserCommentsPage/UserCommentsPage";
import { UserTasksPage } from "./components/Pages/UserTasksPage/UserTasksPage";
import { useSession } from "./hooks/useSession";
import { UserPageAppContext, UserPageAppContextProvider, } from "./providers/UserPageAppContextProvider";
import { UserPageNotificationsContextProvider } from "./providers/UserPageNotificationsContextProvider";
function UserPageContent() {
    const { state: { initialLoading, isActiveUser, setupCompleted }, } = useContext(UserPageAppContext);
    const { isLoggedIn } = useSession();
    if (initialLoading) {
        return _jsx(LoadingPage, {});
    }
    if (!isActiveUser) {
        return (_jsx(ErrorPage, { errorTitle: __("User is not active", "quicktasker"), errorDescription: __("Your user is not active. Please contact site administrator.", "quicktasker") }));
    }
    if (!setupCompleted) {
        return _jsx(SetUpPage, {});
    }
    if (!isLoggedIn()) {
        return _jsx(LoginPage, {});
    }
    return (_jsx(Router, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/user/profile", element: _jsx(PprofilePage, {}) }), _jsx(Route, { path: "/user-tasks", element: _jsx(UserTasksPage, {}) }), _jsx(Route, { path: "/assignable-tasks", element: _jsx(AssignableTasksPage, {}) }), _jsx(Route, { path: "/tasks/:taskHash", element: _jsx(TaskPage, {}) }), _jsx(Route, { path: "/notifications", element: _jsx(NotificationsPage, {}) }), _jsx(Route, { path: "/tasks/:taskHash/comments", element: _jsx(TaskCommentsPage, {}) }), _jsx(Route, { path: "/user/comments", element: _jsx(UserCommentsPage, {}) })] }) }));
}
function UserPageApp() {
    return (_jsx(ErrorBoundary, { children: _jsx(UserPageAppContextProvider, { children: _jsxs(UserPageNotificationsContextProvider, { children: [_jsx(UserPageContent, {}), _jsx(ToastContainer, { closeOnClick: true, position: "bottom-center", toastClassName: "wpqt-bottom-[80px] lg:wpqt-bottom-[20px]", autoClose: 2000 })] }) }) }));
}
export default UserPageApp;
